// DeviceListRequestChip – shows active request id and "Show all" when request filter is active.

import React, { JSX } from 'react';

import type { DeviceListRequestChipProps } from '../types/DeviceListViewProps';

export type { DeviceListRequestChipProps };

export function DeviceListRequestChip({
  activeRequestId,
  requestFilterIds,
  onClear,
  chipClassName,
}: DeviceListRequestChipProps): JSX.Element | null {
  if (!activeRequestId) return null;

  return (
    <div className={chipClassName}>
      <span className="font-medium text-violet-800/80">Request</span>
      <span className="truncate font-mono text-violet-950 max-w-[240px]">{activeRequestId}</span>
      <span className="tabular-nums text-violet-800/80">
        ({requestFilterIds ? requestFilterIds.length : '…'})
      </span>
      <button
        type="button"
        className="text-[11px] font-medium text-violet-700 hover:text-violet-900 hover:underline"
        onClick={onClear}
      >
        Show all
      </button>
    </div>
  );
}
